import { render, staticRenderFns } from "./ModalImportClass.vue?vue&type=template&id=3091ed40&scoped=true"
import script from "./ModalImportClass.vue?vue&type=script&lang=js"
export * from "./ModalImportClass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3091ed40",
  null
  
)

export default component.exports